import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from 'react-intl';
import utils from "../utils/utils";
import {Link, withRouter} from "react-router-dom";
import DATE_FORMAT from "../components/constants/dateFormat";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faReceipt} from "@fortawesome/free-solid-svg-icons";

const MarketplaceAdminPayoutReportsIndex = ({payoutReports, match, intl}) => {
  return (
    <div className="panel">
      <div className="panel__corner">
        <FontAwesomeIcon icon={faReceipt}/>
      </div>
      <h6 className="panel__title">
        <FormattedMessage id={'marketplace.admin.payout.reports.header'}/>
      </h6>

      <table className="table table-striped admin__table">
        <thead>
        <tr>
          <th scope="col">
            <FormattedMessage id={'marketplace.admin.payout.reports.table.id'}/>
          </th>
          <th scope="col">
            <FormattedMessage id={'marketplace.admin.payout.reports.table.date.created'}/>
          </th>
          <th scope="col">
            <FormattedMessage id={'marketplace.admin.payout.reports.table.amount'}/>
          </th>
          <th scope="col">
            <FormattedMessage id={'marketplace.admin.payout.reports.table.commission'}/>
          </th>
          <th scope="col">
            <FormattedMessage id={'marketplace.admin.payout.reports.table.orders.size'}/>
          </th>
          <th scope="col">
            <FormattedMessage id={'marketplace.admin.payout.reports.table.status'}/>
          </th>
          <th scope="col">
            <FormattedMessage id={'marketplace.admin.payout.reports.table.actions'}/>
          </th>
        </tr>
        </thead>
        <tbody>

        {
          payoutReports.map((payoutReport, itemIndex) => {
            const dateCreated = utils.getDateFromString(payoutReport.dateCreated);
            const formattedDateCreated = dateCreated ? dateCreated.format(DATE_FORMAT.display) : '-';

            return (
              <tr key={itemIndex}>
                <th scope="row">
                  <Link className="link" to={`${match.url}/view/${payoutReport.id}`}>
                    #{payoutReport.id}
                  </Link>
                </th>
                <td>
                  {formattedDateCreated}
                </td>
                <td>
                  {payoutReport.amount}€
                </td>
                <td>
                  {payoutReport.commission}€
                </td>
                <td>
                  {payoutReport.orderIds.length}
                </td>
                <td>
                  {payoutReport.status === 'PAID'? (<FormattedMessage id={'marketplace.admin.payout.reports.table.status.paid'}/>): ''}
                </td>
                <td>
                  <Link className="link" to={`${match.url}/view/${payoutReport.id}`}>
                    <FormattedMessage id={'marketplace.admin.payout.reports.table.actions.view'}/>
                  </Link>
                </td>
              </tr>
            );
          })
        }
        </tbody>
      </table>
    </div>
  );
}

MarketplaceAdminPayoutReportsIndex.propTypes = {
  payoutReports: PropTypes.array.isRequired,
};

MarketplaceAdminPayoutReportsIndex.defaultProps = {};

export default injectIntl(withRouter(MarketplaceAdminPayoutReportsIndex));